import React, { useMemo, useRef, type FC } from 'react'
import { useIntl } from 'react-intl'

import { useRecoilCallback, useRecoilValue } from 'recoil'

import { FormElement, Select } from 'mailup-web-components'

import { changeCriterionCallback } from 'Pages/RecipientsList/recoil/callbacks/filters'
import { criterionOptoutTypeState } from 'Pages/RecipientsList/recoil/state/filters'

interface InputOptoutTypeProps {
  index: number
}

const InputOptoutType: FC<InputOptoutTypeProps> = ({ index }) => {
  const intl = useIntl()

  const dirty = useRef<boolean>(false)

  const { channel, optoutType } = useRecoilValue(
    criterionOptoutTypeState(index),
  )

  const changeCriterion = useRecoilCallback(changeCriterionCallback, [])

  const handleChange = (v: any): void => {
    dirty.current = true

    void changeCriterion('optoutType', v, index)
  }

  const options = useMemo(() => {
    return channel === 'email'
      ? [
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseAdminAction',
            }),
            value: 'OptOutPlatform',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseFromImport',
            }),
            value: 'OptOutImport',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseRightToBeForgotten',
            }),
            value: 'OptOutRightToBeForgotten',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseUnsubbcribeLink',
            }),
            value: 'OptOutNewsletterLink',
          },

          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseLinkClientPosta',
            }),
            value: 'OptOutUnsubHttp',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseMailtoClientPosta',
            }),
            value: 'OptOutUnsubMailTo',
          },

          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseSegnalazioneAbuso',
            }),
            value: 'OptOutFBL',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseDestinatarioInattivo',
            }),
            value: 'OptOutInactive',
          },

          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailErrata',
            }),
            value: 'OptOutBounceHB',
          },

          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailErrataDominio',
            }),
            value: 'OptOutBounceDominioErrato',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailErrataSintassi',
            }),
            value: 'OptOutBounceMailErrata',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailErrataCasellaAbbandonata',
            }),
            value: 'OptOutBounceCasellaAbbandonata',
          },

          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailBloccata',
            }),
            value: 'OptOutMailBlocked',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailBloccataBloccoMTA',
            }),
            value: 'OptOutMailBlockedMta',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailBloccataSpam',
            }),
            value: 'OptOutMailBlockedSpam',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseEmailBloccataConfigurazioneMTA',
            }),
            value: 'OptOutMailBlockedConfigMta',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseErroriRipetuti',
            }),
            value: 'OptOutNBH',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseDisiscTemporanea',
            }),
            value: 'OptOutNBHProvisional',
          },
          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseDisiscPermanenete',
            }),
            value: 'OptOutNBHDefinitive',
          },
        ]
      : [
          {
            label: intl.formatMessage({ id: 'Load.OptOutTypeSms.Console' }),
            value: 'OptOutPlatform',
          },
          {
            label: intl.formatMessage({ id: 'Load.OptOutTypeSms.Import' }),
            value: 'OptOutImport',
          },

          {
            label: intl.formatMessage({
              id: 'Load.SearchRecipientsUnsubscribed.SelectCauseRightToBeForgotten',
            }),
            value: 'OptOutRightToBeForgotten',
          },
        ]
  }, [channel, intl])

  const showFeedback = optoutType === undefined && dirty.current

  return (
    <FormElement
      variant={showFeedback ? 'danger' : undefined}
      feedback={
        showFeedback
          ? intl.formatMessage({ id: 'Load.MailupCommon.Required' })
          : undefined
      }
    >
      <Select
        data-mu-test="input-optout-type"
        searchable
        value={optoutType}
        onChange={handleChange}
        options={options}
        placeholder={intl.formatMessage({
          id: 'Load.RecipientsList.InputOptoutTypePlaceholder',
        })}
        error={showFeedback}
      />
    </FormElement>
  )
}

export default InputOptoutType
